module.exports = __webpack_public_path__ + "static/media/profile.57b3a117.png";